import { db } from '@/core/services/firebase'

const getDocumentReference = (collectionName, firestoreDocId) => {
  return db.collection(collectionName).doc(firestoreDocId)
}

export default getDocumentReference
